import mitt from "mitt";

type CookieBusEvents = {
  consent_update: void;
};

export const bus = mitt<CookieBusEvents>();
